export default __webpack_public_path__ + "bg-holiday.f6da96.png";